export const LTAG_PAGE_LINK = 'LTAG Page Link';
export const LAG_PAGE_LINK = 'LAG Page Link';
export const AXAG_PAGE_LINK = 'AXAG Page Link';
export const WELDY_PAGE_LINK = 'WELDY Page Link';
export const LOGOUT_LINK = '/logout';
export const LOGIN_LINK = '/login';
export const ANONYMOUS_STRING = 'anonymous ';
export const ACCESSORIES_PRODUCT_TYPE = 'accessories';
